<template>
	<div v-if="showRoute">
		<left-nav class="left-nav"></left-nav>
		<app-header class="header" :packageInfo="this.packageInfo"></app-header>
		<div class="app-content">
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
import STORE_CONST from '../store/consts'
import LeftNav from '@/components/left-nav'
import AppHeader from '@/components/header'
import { PasswordStrengthMessage } from '../config'
export default {
	name: 'Console',
	data() {
		return {
			showRoute: false,
			open_text: '', // 套餐提醒文本内容
			remainingDays: '', // 套餐剩余天数
			packageInfo: '',
		}
	},
	created() {
		this.$store
			.dispatch(STORE_CONST.ACCOUNT.CURRENT)
			.then((res) => {
				this.showRoute = true
				this.password_ok = res.password_strength ? res.password_strength.password_ok : undefined
				this.showPasswordModal(this.password_ok, this.$store.getters.team.setting.password_strength)
			})
			.catch((err) => {
				if (this.$route.name !== 'login') {
					console.log('login path--', err)
					this.$notify({
						message: this.$gettext(err.data.code),
						type: 'success',
					})
				} else {
					console.log('console', this.$route.name)
				}
			})

		// 套餐提醒
		this.$store.dispatch(STORE_CONST.DASHBOARD.GET_STATISTICS).then((res) => {
			console.log(res, '套餐提醒')
			// res.expire = 1648870056555 //测试用时间戳
			// res.accounts = 10 // 测试用资源数量
			// this.remainingDays = 0  // 测试用剩余天数
			this.packageInfo = res

			if (!res.expire) {
				res.expire = 0
			}
			if (res && res.current_plan) {
				// overflow_limit变量判断是否超过配置限额
				const overflow_limit = (res.accounts > res.current_plan.account_limit && res.current_plan.account_limit != 0) || (res.networks > res.current_plan.network_limit && res.current_plan.network_limit != 0) || (res.resources > res.current_plan.resource_limit && res.current_plan.resource_limit != 0)
				// currentPlan 判断是否是0 是0则表示不限制
				const currentPlan = {
					accountLimit: res.current_plan.account_limit == 0 ? '∞' : res.current_plan.account_limit,
					networkLimit: res.current_plan.network_limit == 0 ? '∞' : res.current_plan.network_limit,
					resourceLimit: res.current_plan.resource_limit == 0 ? '∞' : res.current_plan.resource_limit,
				}

				this.remainingDays = (res.expire - Date.now() / 1000) / 3600 / 24
				const time = new Date(res.expire * 1000)
				const Y = time.getFullYear()
				const M = time.getMonth() + 1 < 10 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1
				const D = time.getDate() < 10 ? '0' + time.getDate() : time.getDate()

				if (res.current_plan.name === '试用版') {
					if (overflow_limit) {
						// 超额
						this.open_text = `您好！您所属团队的 CloudLinker 套餐为${res.current_plan.name}， 当前套餐配额情况：集群数量： ${res.networks} / ${currentPlan.networkLimit}，资源数量: ${res.resources} / ${currentPlan.resourceLimit}，团队成员数: ${res.accounts} / ${currentPlan.accountLimit}，日志可回放天数${res.current_plan.log_back_days}。已超出${res.current_plan.name}套餐配额限制，为避免影响产品功能使用，请及时联系客服升级套餐。`
					} else {
						// 未超额
						this.open_text = `您好！您所属团队的 CloudLinker 套餐为${res.current_plan.name}， 当前套餐配额情况：集群数量： ${res.networks} / ${currentPlan.networkLimit}，资源数量: ${res.resources} / ${currentPlan.resourceLimit}，团队成员数: ${res.accounts} / ${currentPlan.accountLimit}，日志可回放天数${res.current_plan.log_back_days}。为避免影响产品功能使用，建议及时联系客服升级套餐。`
					}
				} else {
					if (overflow_limit) {
						this.open_text = `您好！您所属团队的 CloudLinker 套餐为${res.current_plan.name}， 当前套餐配额情况：集群数量： ${res.networks} / ${currentPlan.networkLimit}，资源数量: ${res.resources} / ${currentPlan.resourceLimit}，团队成员数: ${res.accounts} / ${currentPlan.accountLimit}，日志可回放天数${res.current_plan.log_back_days}。已超出${res.current_plan.name}套餐配额限制，为避免影响产品功能使用，请及时联系客服升级套餐。`
					}
					// 非试用版
					/* if (this.remainingDays > 0 && this.remainingDays <= 30) {
						if (overflow_limit) {
							this.open_text = `您好！您所属团队的 CloudLinker ${res.current_plan.name}套餐将于${Y}年${M}月${D}日到期，当前套餐配额情况：集群数量： ${res.networks} / ${currentPlan.networkLimit}，资源数量: ${res.resources} / ${currentPlan.resourceLimit}，团队成员数: ${res.accounts} / ${currentPlan.accountLimit}，日志可回放天数${res.current_plan.log_back_days}。已超出${res.current_plan.name}套餐配额限制，为避免影响产品功能使用，请及时联系客服升级套餐。`
						} else {
							this.open_text = `您好！您所属团队的 CloudLinker ${res.current_plan.name}套餐将于${Y}年${M}月${D}日到期，当前套餐配额情况：集群数量： ${res.networks} / ${currentPlan.networkLimit}，资源数量: ${res.resources} / ${currentPlan.resourceLimit}，团队成员数: ${res.accounts} / ${currentPlan.accountLimit}，日志可回放天数${res.current_plan.log_back_days}。为避免影响产品功能使用，请及时联系客服续费套餐。`
						}
					} else if (this.remainingDays > 30) {
						if (overflow_limit) {
							this.open_text = `您好！您所属团队的 CloudLinker 套餐为${res.current_plan.name}， 当前套餐配额情况：集群数量： ${res.networks} / ${currentPlan.networkLimit}，资源数量: ${res.resources} / ${currentPlan.resourceLimit}，团队成员数: ${res.accounts} / ${currentPlan.accountLimit}，日志可回放天数${res.current_plan.log_back_days}。已超出${res.current_plan.name}套餐配额限制，为避免影响产品功能使用，请及时联系客服升级套餐。`
						}
					} */
				}
			}

			const hasComboModal = document.cookie.split(';').some((item) => item.includes('comboModal=true'))
			if (this.open_text && !hasComboModal) {
				setTimeout(() => {
					this.open()
				}, 1000)
			}
		})
	},
	computed: {
		level() {
			return this.$store.getters.team.setting.password_strength
		},
	},
	watch: {
		level(val) {
			if (val) {
				this.showPasswordModal(this.password_ok, val)
			}
		},
	},
	methods: {
		showPasswordModal(passwordOk, companyPasswordStrength) {
			const currentHref = window.location.href.split('#')[1].indexOf('/personal/security') >= 0
			console.log('--passwordOk--', passwordOk, '--companyPasswordStrength--', companyPasswordStrength)
			console.log('--currentHref--', currentHref)
			this.$nextTick(() => {
				if (passwordOk !== undefined && passwordOk === false && companyPasswordStrength && !currentHref) {
					const h = this.$createElement
					this.$msgbox({
						title: this.$gettext('prompt'),
						center: true,
						showClose: false,
						showCancelButton: false,
						closeOnClickModal: false,
						confirmButtonText: this.$gettext('Change Password'),
						customClass: 'password_strength_modal',
						beforeClose: (action, instance, done) => {
							console.log('--close-modal-')
							this.$router.push({
								path: '/personal/security',
								query: { changePwd: true },
							})
							done()
						},
						message: h('p', null, [h('p', { style: 'margin-bottom: 20px;' }, this.$gettext('Your current login password complexity does not meet the password strength requirements set by the team administrator. Please change the password before continuing to use.')), h('p', null, this.$gettext(PasswordStrengthMessage[companyPasswordStrength]))]),
					})
				}
			})
		},
		open() {
			const h = this.$createElement
			this.$msgbox({
				title: '套餐提醒',
				closeOnClickModal: false,
				message: h('div', null, [h('p', null, [h('strong', { style: 'line-height:25px' }, this.open_text)]), h('p', { style: 'margin-top:20px;' }, [h('strong', { style: 'margin:0 40px' }, '咨询邮箱: support@jiagouyun.com'), h('strong', null, '热线电话: 021-50653160')])]),
				confirmButtonText: this.$gettext('No more reminders within 7 days'),

				beforeClose: (action, instance, done) => {
					console.log('--close-modal-')
					const hasComboModal = document.cookie.split(';').some((item) => item.includes('comboModal=true'))
					if (!hasComboModal) {
						// 获取当前日期
						var currentDate = new Date()
						// 设置cookie过期时间为3天后
						var expirationDate = new Date(currentDate.getTime() + 24 * 60 * 60 * 1000 * 7) // 24小时后
						// 设置cookie
						document.cookie = 'comboModal=true; expires=' + expirationDate.toUTCString() + '; path=/'
					}
					done()
				},
			})
		},
	},
	components: {
		LeftNav,
		AppHeader,
	},
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import '../assets/css/variable';

.left-nav {
	position: absolute;
	z-index: 1;
	width: 210px;
	background-color: #f60;
	background-color: #3f4253;
	// background-color: #3f4253;
}

.header {
	padding-left: 210px;
	height: 60px;
	background: #fff;
	padding-right: 20px;
	overflow: hidden;
}

.app-content {
	margin-top: -60px;
	padding: 60px 0 0 0;
	min-height: 100%;
	min-height: 100vh;
	// border-left: 211px solid #f8f8f8;
	border-left: 210px solid #3f4253;
	.view-title {
		// padding-left: 20px;
		// padding-right: 20px;
		// height: 60px;
		// line-height: 60px;
		min-height: 60px;
		padding: 15px 20px;
		font-size: 20px;
		color: $titleColor;
		border-bottom: 1px solid $border-color;
		.el-button--text {
			color: $textColor;
		}
	}
	.view-content {
		padding: 15px 20px 15px;
	}
}

.password_strength_modal {
	.el-message-box__btns {
		text-align: center;
	}
}

@media screen and (max-width: 700px) {
	.app-content {
		// border-left: 211px solid #fff;
		border-left: 210px solid #3f4253;
	}
}
.el-message-box {
	width: 600px;
}
</style>



// WEBPACK FOOTER //
// console.vue?97911d8a